import { html } from "../../../../../jb-nexus/node_modules/lit";
import { NexusComponent } from "./nexus.component";

export class LanguageSwitcher extends NexusComponent {
  constructor() {
    super();
  }

  get languages() {
    return this.querySelectorAll(".language-switcher-lang");
  }

  get activeLanguageCode() {
    return window.location.href.includes("/en/") ? "en" : "nl";
  }

  get activeLanguage() {
    return Array.from(this.languages).find(
      (language) => language.dataset.lang === this.activeLanguageCode
    );
  }

  connectedCallback() {
    super.connectedCallback();

    this.setActiveLangauge();
    this.addEventListener("click", this.handleLanguageSwitch);
  }

  setActiveLangauge() {
    this.activeLanguage.classList.add("fw-bold");
  }

  handleLanguageSwitch(event) {
    event.preventDefault();
    window.location.href = this.getNewUrl();
  }

  getNewUrl() {
    return this.activeLanguageCode === "en"
      ? window.location.href.replace("/en/", "/")
      : this.addEnToUrl();
  }

  addEnToUrl() {
    const url = new URL(window.location.href);
    return `${url.origin}/en${url.pathname}${url.search}${url.hash}`;
  }

  render() {
    return html` <slot></slot> `;
  }
}

customElements.define("language-switcher", LanguageSwitcher);
